import { ReactNode } from 'react'

import { makeAutoObservable } from 'mobx'

import { ShowDialog } from './model'

class DialogBottomSheetStore {
  child?: ReactNode
  isShow?: boolean = false
  isDialog?: boolean = true
  isClickable?: boolean = true
  maxHeight?: number | string = ''
  contentMaxHeight?: number | string = ''
  backgroundColor?: string
  borderRadius: number | undefined = 14
  padding?: number[] = [14]

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  onSetDialog({
    child,
    isDialog = true,
    maxHeight,
    isClickable = true,
    contentMaxHeight,
    backgroundColor,
    borderRadius,
    padding,
  }: ShowDialog) {
    this.isShow = true
    this.child = child
    this.isDialog = isDialog
    this.maxHeight = maxHeight
    this.isClickable = isClickable
    this.backgroundColor = backgroundColor
    this.contentMaxHeight = contentMaxHeight
    this.borderRadius = borderRadius
    this.padding = padding

    document.body.style.overflow = 'hidden'
  }

  onHideDialog() {
    this.isShow = false
    this.child = undefined
    this.isDialog = false
    this.borderRadius = 14

    document.body.style.overflow = 'auto'
  }
}

export default new DialogBottomSheetStore()
